<template>
    <div class="leftTop">
        <div class="scrooList">
            <div class="filterBox"></div>
            <p class="title">儿童数据统计</p>
            <div id="pieCharts" style="width: 420px; height: 400px"></div>
        </div>
    </div>
</template>

<script>
// import hdTit from './modulTitle';
// import vueSeamlessScroll from 'vue-seamless-scroll';
import echarts from 'echarts';
export default {
    props: {
        orderData: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            myChart: ''
        };
    },
    computed: {},
    created() {},
    mounted() {
        this.myChart = echarts.init(document.getElementById('pieCharts'), null, {
            devicePixelRatio: 2
        });
    },
    watch: {
        orderData(nVal) {
            console.log(nVal);
            this.setOption();
        }
    },
    methods: {
        setOption() {
            var option = {
                visualMap: {
                    show: false,
                    min: 500,
                    max: 600,
                    inRange: {
                        //colorLightness: [0, 1]
                    }
                },
                series: [
                    {
                        name: '农房信息',
                        type: 'pie',
                        radius: '50%',
                        center: ['50%', '40%'],
                        color: ['rgb(131,249,103)', '#FBFE27', '#FE5050', '#1DB7E5', '#F3972F'],
                        data: this.orderData,
                        roseType: 'radius',

                        label: {
                            normal: {
                                formatter: ['{c}人', '{b}'].join('\n'),
                                rich: {
                                    c: {
                                        color: '#8DEF8B',
                                        fontSize: 20,
                                        fontWeight: 'bold',
                                        lineHeight: 5
                                    },
                                    b: {
                                        color: 'rgb(98,137,169)',
                                        fontSize: 15,
                                        height: 40
                                    }
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                lineStyle: {
                                    color: 'rgb(98,137,169)'
                                },
                                smooth: 0.2,
                                length: 10,
                                length2: 20
                            }
                        }
                    }
                ]
            };

            this.myChart.setOption(option, true);
        }
    },
    components: {}
};
</script>
<style scoped lang="scss">
.leftTop {
    position: absolute;
    top: 154px;
    left: 70px;
    .filterBox {
        background: rgba($color: #000000, $alpha: 0.4);
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        z-index: -1;
        -webkit-filter: blur(9px);
        -moz-filter: blur(9px);
        -o-filter: blur(9px);
        -ms-filter: blur(9px);
        filter: blur(30px);
    }
    .scrooList {
        position: relative;
        // position: relative;
        background: url(../../assets/img/card.png) no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        width: 470px;
        height: 370px;
        margin-top: 10px;
        box-sizing: border-box;
        padding: 18px;
    }
}
.title {
    background: rgba($color: #00c2ff, $alpha: 0.6);
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    padding: 10px;
    display: inline-block;
}
</style>
